export default {
  errors: {
    offer: 'Nabídku se nepodařilo uložit',
    fakeOffer: 'Nabídka není validní',
    application: 'Nepodařilo se načíst žádost',
  },
};
